import { FC, useState } from "react";
import { InputNumber, InputText } from "../../../../components/input";

import { IInputArrayFormProps, IInputArrayDataStructureItem } from "../../../../components/input/arrayData";
import { CreateNotification } from "../../../../components/notifier";
import { getDDMMYYYFormat } from "../../../../helper/dateTimeHelper";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { ObjectUtils } from "../../../../modules/utils";
import { UploadFile } from "../../uploadFile";
import { InputSelectTag } from "../../../../components/input/select-tag";
import { InputDateRangePicker } from "../../../../components/input/date-range-picker";
import { Upload } from "../../upload";
import { InputGroupSelect } from "../../../../components/input/select/select-group";
import { getDefaultEstimatedTimeOfUse, getDefaultGender } from "../../util";

// structure dài hạn cấp mới
export const LongTermNewSercurityCardUnitsFormStructure: IInputArrayDataStructureItem[] = [
  {
    name: "name",
    label: "Họ và tên",
    isVisibleOnList: true,
  },
  {
    name: "sex",
    label: "Giới tính",
    isVisibleOnList: true,
  },
  {
    name: "personalId",
    label: "CMND/CCCD/Hộ chiếu",
    isVisibleOnList: true,
  },
  {
    name: "regency",
    label: "Chức vụ",
    isVisibleOnList: true,
  },
  {
    name: "unit",
    label: "Đơn vị",
    isVisibleOnList: true,
  },
  // {
  //   name: "KSANCardNumberIssued",
  //   label: "Số thẻ KSAN đã cấp(nếu có)",
  //   isVisibleOnList: true,
  // },
  {
    name: "grantTerm",
    label: "Thời hạn cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantedArea",
    label: "Khu vực được cấp",
    isVisibleOnList: true,
  },
  // {
  //   name: "photocopyOfIDCard",
  //   label: "Giấy CMND photo công chứng (6 tháng)",
  //   isVisibleOnList: true,
  // },
  {
    name: "cardPhoto",
    label: "Ảnh thẻ 4x6 phông trắng, nền trắng (6 tháng)",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfCriminalRecord",
    label: "Bản photo lý lịch tư pháp (6 tháng)",
    isVisibleOnList: true,
  },
  {
    name: "personalStatement",
    label: "Bản khai cá nhân",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfLaborContract",
    label: "Bản photo hợp đồng lao động giữa người lao động với công ty",
    isVisibleOnList: true,
  },
  {
    name: "note",
    label: "Ghi chú",
    isVisibleOnList: true,
  },
];
// structure dài hạn gia hạn
export const LongTermEvictSercurityCardUnitsFormStructure: IInputArrayDataStructureItem[] = [
  {
    name: "name",
    label: "Họ và tên",
    isVisibleOnList: true,
  },
  {
    name: "sex",
    label: "Giới tính",
    isVisibleOnList: true,
  },
  {
    name: "personalId",
    label: "CMND/CCCD/Hộ chiếu",
    isVisibleOnList: true,
  },
  {
    name: "regency",
    label: "Chức vụ",
    isVisibleOnList: true,
  },
  {
    name: "unit",
    label: "Đơn vị",
    isVisibleOnList: true,
  },
  {
    name: "KSANCardNumberIssued",
    label: "Số thẻ KSAN đã cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantTerm",
    label: "Thời hạn cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantedArea",
    label: "Khu vực được cấp",
    isVisibleOnList: true,
  },
  // {
  //   name: "photocopyOfIDCard",
  //   label: "Giấy CMND photo công chứng (6 tháng)",
  //   isVisibleOnList: true,
  // },
  {
    name: "cardPhoto",
    label: "Ảnh thẻ 4x6 phông trắng, nền trắng (2 năm)",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfCriminalRecord",
    label: "Bản photo lý lịch tư pháp",
    isVisibleOnList: true,
  },
  {
    name: "personalStatement",
    label: "Bản khai cá nhân",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfLaborContract",
    label: "Bản photo hợp đồng lao động giữa người lao động với công ty",
    isVisibleOnList: true,
  },
  {
    name: "photoOldKSAN",
    label: "Bản photo ảnh thẻ KSAN cũ",
    isVisibleOnList: true,
  },

  {
    name: "note",
    label: "Ghi chú",
    isVisibleOnList: true,
  },
];
// structure dài hạn cấp lại
export const longTermRenewSecurityControlCardStructure: IInputArrayDataStructureItem[] = [
  {
    name: "name",
    label: "Họ và tên",
    isVisibleOnList: true,
  },
  {
    name: "sex",
    label: "Giới tính",
    isVisibleOnList: true,
  },
  {
    name: "personalId",
    label: "CMND/CCCD/Hộ chiếu",
    isVisibleOnList: true,
  },
  {
    name: "regency",
    label: "Chức vụ",
    isVisibleOnList: true,
  },
  {
    name: "unit",
    label: "Đơn vị",
    isVisibleOnList: true,
  },
  {
    name: "KSANCardNumberIssued",
    label: "Số thẻ KSAN đã cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantTerm",
    label: "Thời hạn cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantedArea",
    label: "Khu vực được cấp",
    isVisibleOnList: true,
  },
  // {
  //   name: "photocopyOfIDCard",
  //   label: "Giấy CMND photo công chứng (6 tháng)",
  //   isVisibleOnList: true,
  // },
  {
    name: "cardPhoto",
    label: "Ảnh thẻ 4x6 phông trắng, nền trắng",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfCriminalRecord",
    label: "Bản photo lý lịch tư pháp",
    isVisibleOnList: true,
  },
  {
    name: "personalStatement",
    label: "Bản khai cá nhân",
    isVisibleOnList: true,
  },
  {
    name: "photocopyOfLaborContract",
    label: "Bản photo hợp đồng lao động giữa người lao động với công ty",
    isVisibleOnList: true,
  },
  {
    name: "photoOldKSAN",
    label: "Bản photo thẻ kiểm soát an ninh cũ",
    isVisibleOnList: true,
  },
  {
    name: "ExcuseLose",
    label: "Đơn cớ mất",
    isVisibleOnList: true,
  },
  {
    name: "note",
    label: "Ghi chú",
    isVisibleOnList: true,
  },
];
// form dài hạn cấp mới
export const LongTermNewSecurityControlCardContentForm: FC<IInputArrayFormProps> = (props: any) => {
  const { childFormData } = props;
  const today = new Date();
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(getDefaultEstimatedTimeOfUse(childFormData?.grantTerm));

  const genderSelect = [
    { label: "Nam", value: "male" },
    { label: "Nữ", value: "female" },
  ];
  const [gender, setGender] = useState(getDefaultGender(childFormData?.sex, genderSelect[0].value, genderSelect));
  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item: any) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      values.grantTerm = estimatedTimeOfUse
        ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1])
        : values.grantTerm;
      // values.unit = selectedTeam ? selectedTeam.value : values.unit;
      values.sex = gender && gender === "male" ? "Nam" : "Nữ";
      // values.grantedArea = values.grantedArea.length > 0 && JSON.stringify(values.grantedArea);

      if (
        !values.name ||
        !values.sex ||
        !values.personalId ||
        !values.regency ||
        !values.unit ||
        // !values.KSANCardNumberIssued ||
        !values.grantTerm ||
        !values.grantedArea
        // !values.cardPhoto ||
        // !values.photocopyOfCriminalRecord ||
        // !values.personalStatement ||
        // !values.photocopyOfLaborContract
      ) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      } else props.onSubmit(values);
    },
  });

  const onGenderChange = (selectedOptions: any) => {
    setGender(selectedOptions);
  };

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc phải nhập{" "}
      </h6>

      <InputWraper
        inputProps={getInputProps("unit")}
        renderInput={(s) => <InputText {...s} />}
        // <InputSelect {...s}
        //     options={props.teamList.map((o: any) => ({
        //       id: o.id,
        //       label: o.value,
        //       value: o.value,
        //     }))}
        //     value={selectedTeam?.value}
        //     onChange={onTeamChange}
        //     placeholder="* Chọn Đơn vị"
        // />}
        isRequired
      />

      <InputWraper inputProps={getInputProps("name")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("sex")}
        renderInput={(s) => (
          <InputSelectTag {...s} options={genderSelect} value={gender} onChange={onGenderChange} gender={gender} />
        )}
        isRequired
      />

      <InputWraper inputProps={getInputProps("personalId")} renderInput={(s) => <InputNumber {...s} />} isRequired />

      <InputWraper inputProps={getInputProps("regency")} renderInput={(s) => <InputText {...s} />} isRequired />

      {/* <InputWraper
        inputProps={getInputProps("KSANCardNumberIssued")}
        renderInput={(s) => <InputText {...s} />}
      /> */}

      <InputWraper
        inputProps={getInputProps("grantTerm")}
        renderInput={(s) => (
          <InputDateRangePicker {...s} value={estimatedTimeOfUse} onChange={setEstimatedTimeOfUse} minDate={today} />
        )}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantedArea")}
        renderInput={(s) => <InputGroupSelect {...s} />}
        isRequired
      />

      {/* <InputWraper
        inputProps={getInputProps("photocopyOfIDCard")}
        renderInput={(s) => <UploadFile {...s} />}
        isRequired
      /> */}

      <InputWraper
        inputProps={getInputProps("cardPhoto")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photocopyOfCriminalRecord")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("personalStatement")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photocopyOfLaborContract")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper inputProps={getInputProps("note")} renderInput={(s) => <InputText {...s} />} />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
// form dài hạn gia hạn
export const LongTermEvictSecurityControlCardContentForm: FC<IInputArrayFormProps> = (props: any) => {
  const { childFormData } = props;
  const today = new Date();
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(getDefaultEstimatedTimeOfUse(childFormData?.grantTerm));
  const genderSelect = [
    { label: "Nam", value: "male" },
    { label: "Nữ", value: "female" },
  ];
  const [gender, setGender] = useState(getDefaultGender(childFormData?.sex, genderSelect[0].value, genderSelect));

  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item: any) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      values.grantTerm = estimatedTimeOfUse
        ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1])
        : values.grantTerm;
      // values.unit = selectedTeam ? selectedTeam.value : values.unit;
      values.sex = gender && gender === "male" ? "Nam" : "Nữ";
      // values.grantedArea = values.grantedArea.length > 0 && JSON.stringify(values.grantedArea);

      // const imgSrc = values.photocopyOfIDCard;
      // values.photocopyOfIDCard = <img src={imgSrc} width={50} height={50}></img>;
      if (
        !values.name ||
        !values.sex ||
        !values.personalId ||
        !values.regency ||
        !values.unit ||
        !values.KSANCardNumberIssued ||
        !values.grantTerm ||
        !values.grantedArea
        // !values.photocopyOfIDCard ||
        // !values.cardPhoto ||
        // !values.photocopyOfCriminalRecord ||
        // !values.personalStatement ||
        // !values.photocopyOfLaborContract
        // !values.photoOldKSAN
      ) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      } else props.onSubmit(values);
    },
  });

  const onGenderChange = (selectedOptions: any) => {
    setGender(selectedOptions);
  };

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc phải nhập{" "}
      </h6>

      <InputWraper
        inputProps={getInputProps("unit")}
        renderInput={(s) => <InputText {...s} />}
        // <InputSelect {...s}
        //   options={props.teamList.map((o: any) => ({
        //     id: o.id,
        //     label: o.value,
        //     value: o.value,
        //   }))}
        //   value={selectedTeam?.value}
        //   onChange={onTeamChange}
        //   placeholder="* Chọn Đơn vị"
        // />}
        isRequired
      />

      <InputWraper inputProps={getInputProps("name")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("sex")}
        renderInput={(s) => (
          <InputSelectTag {...s} options={genderSelect} value={gender} onChange={onGenderChange} gender={gender} />
        )}
        isRequired
      />

      <InputWraper inputProps={getInputProps("personalId")} renderInput={(s) => <InputNumber {...s} />} isRequired />

      <InputWraper inputProps={getInputProps("regency")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("KSANCardNumberIssued")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantTerm")}
        renderInput={(s) => (
          <InputDateRangePicker {...s} value={estimatedTimeOfUse} onChange={setEstimatedTimeOfUse} minDate={today} />
        )}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantedArea")}
        renderInput={(s) => <InputGroupSelect {...s} />}
        isRequired
      />

      {/* <InputWraper
        inputProps={getInputProps("photocopyOfIDCard")}
        renderInput={(s) => <UploadFile {...s} />}
        isRequired
      /> */}

      <InputWraper
        inputProps={getInputProps("cardPhoto")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photocopyOfCriminalRecord")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("personalStatement")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photocopyOfLaborContract")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photoOldKSAN")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper inputProps={getInputProps("note")} renderInput={(s) => <InputText {...s} />} />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
// form dài hạn cấp lại
export const LongTermRenewSecurityControlCardContentForm: FC<IInputArrayFormProps> = (props: any) => {
  const { childFormData } = props;
  const today = new Date();
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(getDefaultEstimatedTimeOfUse(childFormData?.grantTerm));
  const genderSelect = [
    { label: "Nam", value: "male" },
    { label: "Nữ", value: "female" },
  ];
  const [gender, setGender] = useState(getDefaultGender(childFormData?.sex, genderSelect[0].value, genderSelect));
  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item: any) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      // values.unit = selectedTeam ? selectedTeam.value : values.unit;
      values.sex = gender && gender === "male" ? "Nam" : "Nữ";
      values.grantTerm = estimatedTimeOfUse
        ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1])
        : values.grantTerm;
      values.ExcuseLose = values.ExcuseLose.length > 0 && JSON.stringify(values.ExcuseLose);
      // values.grantedArea = values.grantedArea.length > 0 && JSON.stringify(values.grantedArea);

      if (
        !values.name ||
        !values.sex ||
        !values.personalId ||
        !values.regency ||
        !values.unit ||
        !values.KSANCardNumberIssued ||
        !values.grantTerm ||
        !values.grantedArea ||
        // !values.photocopyOfIDCard ||
        // !values.cardPhoto ||
        // !values.photocopyOfCriminalRecord ||
        // !values.personalStatement ||
        // !values.photocopyOfLaborContract ||
        // !values.photoOldKSAN ||
        !values.ExcuseLose
      ) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      } else props.onSubmit(values);
    },
  });

  const onGenderChange = (selectedOptions: any) => {
    setGender(selectedOptions);
  };

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc phải nhập{" "}
      </h6>

      <InputWraper
        inputProps={getInputProps("unit")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
        // <InputSelect {...s}
        //     options={props.teamList.map((o: any) => ({
        //       id: o.id,
        //       label: o.value,
        //       value: o.value,
        //     }))}
        //     value={selectedTeam?.value}
        //     onChange={onTeamChange}
        //     placeholder="* Chọn Đơn vị"
        // />}
      />

      <InputWraper inputProps={getInputProps("name")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("sex")}
        renderInput={(s) => (
          <InputSelectTag {...s} options={genderSelect} value={gender} onChange={onGenderChange} gender={gender} />
        )}
        isRequired
      />

      <InputWraper inputProps={getInputProps("personalId")} renderInput={(s) => <InputNumber {...s} />} isRequired />

      <InputWraper inputProps={getInputProps("regency")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("KSANCardNumberIssued")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantTerm")}
        renderInput={(s) => (
          <InputDateRangePicker {...s} value={estimatedTimeOfUse} onChange={setEstimatedTimeOfUse} minDate={today} />
        )}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantedArea")}
        renderInput={(s) => <InputGroupSelect {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("cardPhoto")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photocopyOfCriminalRecord")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("personalStatement")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photocopyOfLaborContract")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper
        inputProps={getInputProps("photoOldKSAN")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />
      <InputWraper inputProps={getInputProps("ExcuseLose")} renderInput={(s) => <Upload {...s} />} isRequired />
      <InputWraper inputProps={getInputProps("note")} renderInput={(s) => <InputText {...s} />} />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
